/**
 * A button label with a short form below 380px. There "Kostenloser
 * 60-Sekunden-Check" (or the longer Ukrainian and Russian labels) broke into
 * two lines inside the pill, split after "60-Sekunden-" (audit 18.10.2026;
 * 360px was too low: the sub-page hero broke it up to 390px).
 * Only the visible span is read out; the other is display:none.
 */
export function CtaLabel({ long, short }: { long: string; short: string }) {
  return (
    <>
      <span className="max-[379px]:hidden">{long}</span>
      <span className="hidden max-[379px]:inline">{short}</span>
    </>
  );
}
